import React from 'react';
import InternationalCardBanner from '../booking/InternationalCardBanner';

/** Flights search card — international cards first for overseas travelers. */
function FlightsNepalPayStrip({ compact = false, panelTop = false }) {
	return (
		<InternationalCardBanner
			layout="panel"
			panelTop={panelTop}
			compact={compact}
			showLocalWallets
		/>
	);
}

export default FlightsNepalPayStrip;
